import actions from './pt-br/actions'
import dialogs from './pt-br/dialogs'
import drawer from './pt-br/drawer'
import httpErrors from './pt-br/httpErrors'
import popups from './pt-br/popups'
import resources from './pt-br/resources'
import routes from './pt-br/routes'

export default {
    actions: actions,
    dialogs: dialogs,
    drawer: drawer,
    httpErrors: httpErrors,
    popups: popups,
    resources: resources,
    routes: routes,

    'money-config': {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
    },

    form: {
        actions: {
            back: 'Voltar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Remover',
            create: 'Criar',
            show: 'Ver detalhes',
            no_action_available: 'Nenhuma ação adicional disponível',
            restore: 'Restaurar',
            select: 'Selecionar',
        },
        messages: {
            'validation-error': 'Preencha o formulário corretamente.',
        },
        status: {
            active: 'Ativo',
            disabled: 'Inativo',
        },
    },

    tables: {
        actions: 'Ações',
    },

    content: {
        'table-texts': {
            title: 'Título',
            type: 'Tipo',
            actions: 'Ações',
        },
    },

    email: {
        'table-texts': {
            title: 'Título',
            active: 'Ativo',
            actions: 'Ações',
        },
    },

    /** DIALOGS */
    'dialogs-confirm': {
        buttons: {
            no: 'Não',
            yes: 'Sim',
            confirm: 'Confirmar',
            cancel: 'Cancelar',
            remove: 'Remover',
            restore: 'Restaurar',
            create: 'Criar',
        },
    },

    'dialogs-user-edit': {
        texts: {
            welcome: 'Seja bem vindo ao painel de parceria ConnectPlug!!',
            'change-password':
                'Identificamos que ainda não alterou a senha padrão gerada pelo sistema, por favor utilize o formulário abaixo para atualiza-la.',
        },
    },

    'dialog-plan-logs': {
        table: {
            name: 'Nome',
            modules: 'Módulos',
            date: 'Data Ativação',
            value: 'Valor',
        },
        texts: {
            title: 'Histórico de alterações',
            empty: 'Não há dados disponíveis',
        },
        buttons: {
            show: 'Histórico de Alterações',
        },
    },
    /** /DIALOGS */

    'sarala-table': {
        labels: {
            search: 'Pesquisar',
        },
    },

    colors: {
        texts: {
            title: 'Editar Cores ERP',
            subtitle: 'Pré visualização',
            copyright: '{legal-name}. Política de privacidade | Termos de uso',

            colors: {
                'navigation-background': 'Fundo navegação',
                'navigation-text': 'Texto navegação',
                'menu-background': 'Fundo Menu',
                'menu-text': 'Texto menu',
                'highlight-background': 'Fundo destaque',
                'highlight-text': 'Texto destaque',
            },

            'navbar-items': {
                titles: {
                    t0: 'VENDAS',
                    t1: 'ESTOQUE',
                    t2: 'FINANCEIRO',
                    t3: 'RELATÓRIOS',
                },

                subtitles: {
                    s0: 'Geral',
                    s1: 'Serviços',
                    s2: 'Compras',
                    s3: 'Movimentações',
                    s4: 'Financeiro',
                    s5: 'Logística',
                    s6: 'Clientes',
                },
                items: {
                    i0: 'PROPOSTA',
                    i1: 'PEDIDOS',
                    i2: 'VENDAS',
                    i3: 'NF-E',
                    i4: 'NFS-E',
                    i5: 'ORDEM DE SERVIÇO',
                    i6: 'CONTRATO DE VENDAS',
                    i7: 'PEDIDO DE COMPRA',
                    i8: 'COMPRAS',
                    i9: 'NF-E DE ENTRADA',
                    i10: 'CONTAS A PAGAR',
                    i11: 'CONTAS A RECEBER',
                    i12: 'RESULTADOS',
                    i13: 'ANÁLISE DE CENTRO DE VENDAS',
                    i14: 'FECHAMENTO DE CAIXA',
                    i15: 'VENDAS',
                    i16: 'DESPESAS',
                    i17: 'ESTOQUE',
                    i18: 'CRÉDITO DE CLIENTES',
                    i19: 'ATENDIMENTO DE MESAS',
                },
            },

            'footer-items': {
                titles: {
                    t0: 'CONTATO',
                    t1: 'SUPORTE',
                    t2: 'NEWSLETTER',
                },
            },
        },

        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },

        bus: {
            'save-error': 'Preencha o formulário corretamente.',
            'save-success': 'Cores editadas com sucesso.',
        },

        messages: {
            'navigation-background-error-required':
                'Selecione a cor da barra de navegação.',
            'menu-background-error-required':
                'Selecione a cor de fundo dos menus.',
            'highlight-background-error-required':
                'Selecione a cor do elemento em destaque.',
            'navigation-text-error-required':
                'Selecione a cor do texto da barra de navegação.',
            'menu-text-error-required': 'Selecione a cor do texto dos menus.',
            'highlight-text-error-required':
                'Selecione a cor do texto do elemento em destaque.',
        },
    },

    'contents-form': {
        texts: {
            title: 'Editar Conteúdo',
        },

        labels: {
            title: 'Titulo',
        },

        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },
        bus: {
            'save-error': 'Preencha o formulário corretamente.',
            'save-success': 'Conteúdo {content} editado com sucesso.',
        },

        messages: {
            'title-error-required': 'Título é obrigatorio.',
        },
    },

    'contents-index': {
        buttons: {
            create: 'Adicionar Conteúdo',
        },

        bus: {
            'delete-error': 'Erro ao remover o conteúdo {content}.',
            'delete-success': 'Conteúdo {content} removido com sucesso.',
        },

        messages: {
            delete: 'Remover?',
            'delete-confirmation':
                'Tem certeza que deseja remover o conteúdo {content}?',
            'max-content': 'Máximo de conteúdos atingido.',
        },
    },

    'contents-create': {
        buttons: {
            create: 'Adicionar',
        },
    },

    'contents-edit': {
        texts: {
            'title-prefix': 'Editar',
        },
    },

    'emails-form': {
        texts: {
            title: '{title-prefix} configuração de email',
        },

        labels: {
            title: 'Título',
            from: 'Nome (from)',
            host: 'Host',
            door: 'Porta',
            user: 'Usuário',
            password: 'Senha',
            cryptography: 'Criptografia',
            'test-recipient': 'Destinatário do email de teste',
            active: 'Ativo',
        },

        buttons: {
            save: 'Salvar',
            clean: 'Limpar',
            'test-configuration': 'Testar configuração',
        },

        bus: {
            'save-error': 'Preencha o formulário corretamente.',
            'save-success':
                'Configuração de email {email} editada com sucesso.',
            'test-error': 'Preencha o formulário corretamente.',
            'test-success':
                'Email enviado com sucesso, verifique sua caixa de entrada.',
            'configurations-error': 'Configurações inválidas.',
        },

        messages: {
            'configuration-active': 'Configuração de email ativa',
            'configuration-active-confirmation':
                'Ao definir essa configuração como ativa, todas as outras configurações serão inativadas automaticamente, deseja prosseguir?',
            'title-error-max-length':
                'O título deve conter no máximo 50 caracteres.',
            'title-error-required': 'Título é obrigatorio.',
            'host-error-required': 'Host é obrigatorio.',
            'host-error-max-length':
                'Host deve conter no máximo 255 caracteres.',
            'door-error-required': 'Porta é obrigatorio.',
            'door-error-maxValue': 'O valor máximo da porta é 64000.',
            'door-error-integer': 'Porta deve ser um inteiro.',
            'user-error-required': 'Usuário é obrigatorio.',
            'user-error-max-length':
                'Usuário deve conter no máximo 80 caracteres.',
            'from-error-required': 'Nome (from) é obrigatorio.',
            'from-error-max-length':
                'Nome (from) deve conter no máximo 80 caracteres.',
            'password-error-required': 'Senha é obrigatorio.',
            'password-error-max-length':
                'Senha deve conter no máximo 80 caracteres.',
            'cryptography-error-max-length':
                'Criptografia deve conter no máximo 20 caracteres.',
        },
    },

    'emails-create': {
        texts: {
            'title-prefix': 'Adicionar',
        },
    },

    'emails-edit': {
        texts: {
            'title-prefix': 'Editar',
        },
    },

    'emails-index': {
        buttons: {
            create: 'Adicionar configuração de email',
        },

        bus: {
            'delete-error': 'Erro ao remover a configuração de email {email}.',
            'delete-success':
                'Configuração de email {email} removida com sucesso.',
        },

        messages: {
            delete: 'Remover?',
            'delete-confirmation':
                'Tem certeza que deseja remover a configuração de email {email}',
        },
    },

    'reseler-edit': {
        texts: {
            title: 'Editar Empresa',
        },

        labels: {
            'trade-name': 'Nome Fantasia',
            'legal-name': 'Razão Social',
            'tenant-code': 'Código da empresa',
            logo: 'Logo',
            favicon: 'Favicon',
            'logo-pick': 'Selecionar uma Logo',
            'favicon-pick': 'Selecionar um ícone',
        },

        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },

        bus: {
            'request-error': 'Ocorreu um erro ao atualizar a empresa.',
            'save-error': 'Preencha o formulário corretamente.',
            'save-success': 'Empresa {trade-name} editada com sucesso.',
        },

        messages: {
            'tenant-code-alteration': 'Mudança no código da empresa.',
            'tenant-code-alteration-confirmation':
                'Todos os usuários logados nessa empresa serão deslogados ao efetuar a mudança. Deseja prosseguir com a alteração?',
            'trade-name-error-max-length':
                'O nome fantasia deve conter no máximo 120 caracteres.',
            'trade-name-error-required': 'Nome fantasia é obrigatorio.',
            'legal-name-error-max-length':
                'A razão social deve conter no máximo 180 caracteres.',
            'legal-name-error-required': 'Razão Social é obrigatorio.',
            'tenant-code-error-max-length':
                'O código da empresa deve conter no máximo 20 caracteres.',
            'tenant-code-error-required': 'Código da empresa é obrigatorio.',
        },
    },

    'users-form': {
        texts: {
            title: '{title-prefix} Usuário',
        },

        labels: {
            name: 'Nome',
            email: 'Email',
            password: 'Senha',
            'password-confirmation': 'Confirmação da senha',
            'change-email': 'Alterar email',
        },

        buttons: {
            clean: 'Limpar',
            save: 'Salvar',
        },

        bus: {
            'confirmation-email-sent': 'Email de confirmação enviado.',
            'save-error': 'Preencha o formulário corretamente.',
            'save-success': 'Usuário {name} editado com sucesso.',
        },

        messages: {
            'name-error-max-length':
                'O nome deve conter no máximo 180 caracteres.',
            'name-error-required': 'Nome é obrigatorio.',
            'email-error-required': 'O email é obrigatório.',
            'email-error-email': 'O email deve ser válido.',
            'password-error-required': 'Senha é obrigatorio.',
            'password-error-min-length':
                'A senha deve conter pelo menos 6 caracteres.',
            'password-error-confirmation':
                'A confirmação da seha deve ser igual a senha.',
            'alert-permission-user-1':
                'O primeiro usuário da conta possui todas as permissões liberadas!',
            'change-email-message':
                'Vamos enviar um email de confirmação para alterar o email do usuário.',
        },
    },

    'users-create': {
        texts: {
            'title-prefix': 'Adicionar',
        },
    },

    'users-edit': {
        texts: {
            'title-prefix': 'Editar',
        },
    },

    'users-index': {
        buttons: {
            create: 'Adicionar usuário',
        },

        bus: {
            'delete-error': 'Erro ao remover o usuário {name}.',
            'delete-success': 'Usuário {name} removido com sucesso.',
        },

        messages: {
            delete: 'Remover?',
            'delete-confirmation':
                'Tem certeza que deseja remover o usuário {name}',
        },
    },

    'app-layout': {
        texts: {
            dashboard: 'Dashboard',
            'loading-application': 'Carregando aplicação...',
            exit: 'Sair',
            whitelabel: 'White Label CPlug',
            resale: 'Parceiros CPlug',
            changedEmail: 'Email alterado com sucesso',
        },
    },

    address: {
        routes: {
            index: 'enderecos',
            create: 'enderecos/criar',
            edit: 'enderecos/editar',
        },
        breadcrumbs: {
            index: 'Endereços',
            create: 'Criar',
            edit: 'Editar',
            show: 'Dados',
        },

        index: {
            buttons: {
                create: 'Adicionar Endereço',
            },
            table: {
                address: 'Endereço',
                'city-state': 'Cidade/Estado',
                active: 'Ativo',
                'active-yes': 'SIM',
                'active-no': 'NÃO',
                fiscal_address: 'Endereço Fiscal',
            },
            loading: 'Carregando...',

            filters: {
                all: 'Todos',
                active: 'Ativos',
                inactive: 'Inativos',
            },

            bus: {
                'delete-error': 'Erro ao remover o endereço {address}.',
                'delete-success': 'Endereço {address} removido com sucesso.',
                'restore-error': 'Erro ao restaurar o endereço {address}.',
                'restore-success': 'Endereço {address} restaurado com sucesso.',
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover o endereço {address}?',
                restore: 'Restaurar?',
                'restore-confirmation':
                    'Tem certeza que deseja restaurar o endereço {address}?',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Endereço',
            },

            labels: {
                'zip-code': 'CEP',
                street: 'Rua',
                number: 'Número',
                district: 'Bairro',
                complement: 'Complemento',
                city: 'Cidade',
                state: 'Estado',
                active: 'Ativo',
                yes: 'Sim',
                no: 'Não',
                fiscal_address: 'Endereço Fiscal',
            },

            buttons: {
                save: 'Salvar',
            },

            bus: {
                'save-success': 'Endereço {address} salvo com sucesso.',
            },

            errors: {
                'zip-code-max-length': 'O CEP deve ter no máximo 9 caracteres.',
                'street-required-if':
                    'A rua é obrigatória se o CEP for informado.',
                'street-max-length': 'A rua deve ter no máximo 100 caracteres.',
                'number-max-length':
                    'O número deve ter no máximo 10 caracteres.',
                'district-required-if':
                    'O bairro é obrigatório se a rua for informada.',
                'district-max-length':
                    'o bairro deve ter no máximo 80 caracteres.',
                'complement-max-length':
                    'O complemento deve ter no máximo 255 caracteres.',
                'city-required-if':
                    'A cidade é obrigatória se a rua for informada.',
                'city-max-length':
                    'A cidade deve ter no máximo 150 caracteres.',
                'state-max-length':
                    'O estado deve ter no máximo 150 caracteres.',
            },
        },
    },

    'bank-account': {
        routes: {
            index: 'contas-bancarias',
            create: 'contas-bancarias/criar',
            edit: 'contas-bancarias/editar',
        },
        breadcrumbs: {
            index: 'Contas Bancárias',
            create: 'Criar',
            edit: 'Editar',
            show: 'Dados',
        },

        index: {
            buttons: {
                create: 'Adicionar Conta Bancária',
            },
            table: {
                name: 'Nome',
                bank: 'Banco',
                agency: 'Agência',
                'account-number': 'Conta',
                document: 'CNPJ',
                pix: 'Pix',
                'bank-code': 'Código',
                active: 'Ativa',
                'active-yes': 'SIM',
                'active-no': 'NÃO',
            },
            loading: 'Carregando...',

            filters: {
                all: 'Todas',
                active: 'Ativas',
                inactive: 'Inativas',
            },

            bus: {
                'delete-error':
                    'Erro ao remover a conta bancária {bank-account}.',
                'delete-success':
                    'Conta bancária {bank-account} removida com sucesso.',
                'restore-error':
                    'Erro ao restaurar a conta bancária {bank-account}.',
                'restore-success':
                    'Conta bancária {bank-account} restaurada com sucesso.',
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover a conta {bank-account}?',
                restore: 'Restaurar?',
                'restore-confirmation':
                    'Tem certeza que deseja restaurar a conta {bank-account}?',
                'restore-one-active':
                    'Tem certeza que deseja restaurar a conta {bank-account}? Só é permitido ter uma conta bancária ativa. Ao restaurar essa conta, todas as outras contas serão desativadas.',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Conta Bancária',
            },

            labels: {
                name: 'Nome',
                bank: 'Banco',
                agency: 'Agência',
                'account-number': 'Número da Conta',
                document: 'CNPJ',
                pix: 'Pix',
                active: 'Ativa',
                yes: 'Sim',
                no: 'Não',
            },

            hint: {
                name: 'Nome do titular da conta',
                'account-number': 'Número da conta com o dígito verificador',
                document: 'CNPJ da empresa',
            },

            buttons: {
                save: 'Salvar',
            },

            bus: {
                'save-success':
                    'Conta bancária {bank-account} salva com sucesso.',
            },

            errors: {
                'name-required': 'O nome é obrigatorio.',
                'name-max-length': 'O nome deve ter no máximo 100 caracteres.',
                'bank-id-required-if':
                    'O banco é obrigatório se a agência for informada.',
                'agency-required-if':
                    'A agência é obrigatória se o número da conta for informado.',
                'agency-max-length':
                    'A agência deve ter no máximo 10 caracteres.',
                'account-number-required-if':
                    'O número da conta é obrigatório se a agência for informada.',
                'account-number-max-length':
                    'O número da conta deve ter no máximo 20 caracteres.',
                'document-required-if':
                    'O CNPJ é obrigatório se a agência for informada.',
                'document-max-required':
                    'O documento deve ter no máximo 18 caracteres.',
                'pix-max-length': 'O pix deve ter no máximo 100 caracteres.',
            },
        },
        dialogs: {
            buttons: {
                'one-active': 'Sim, ativar essa conta',
            },
            messages: {
                'one-active': {
                    title: 'Confirmar conta ativa',
                    text:
                        'Só é permitido ter uma conta bancária ativa. Ao salvar essa conta, as outras serão automaticamente desativadas. Deseja continuar?',
                },
            },
        },
    },

    bills: {
        routes: {
            index: 'faturas',
            edit: 'faturas/editar',
        },
        breadcrumbs: {
            index: 'Faturas',
            edit: 'Editar',
        },

        index: {
            tab: {
                pending: 'Pendentes',
                paid: 'Pagas',
            },
            table: {
                month: 'Mês',
                year: 'Ano',
                value: 'Valor',
                paid: 'Pago',
            },
            texts: {
                blocked: {
                    title: 'Acesso Restrito por Inadimplência',
                    message:
                        'Seu acesso foi suspenso devido a pendências financeiras. Regularize as faturas em aberto abaixo para reativar seu acesso completo.',
                },
            },
        },

        show: {
            reference: 'Referência',
            'total-value': 'Valor Total',
            values: 'Valores',
            pending: 'Pendente',
            paid: 'Pago',

            labels: {
                value: 'Valor',
                discount: 'Desconto',
                fees: 'Juros',
            },

            table: {
                customer: 'Cliente',
                value: 'Valor',
            },
        },
    },

    commissions: {
        routes: {
            index: 'comissoes',
            show: 'comissoes/show',
        },
        breadcrumbs: {
            index: 'Comissões',
            show: 'Exibir',
        },
    },

    customer: {
        routes: {
            index: 'clientes',
            create: 'clientes/criar',
            edit: 'clientes/editar',
            show: 'clientes/dados',
        },
        breadcrumbs: {
            index: 'Clientes',
            create: 'Novo',
            edit: 'Editar',
            show: 'Dados',
        },

        tabs: {
            title: 'Cliente',
        },

        title: '{title-prefix} Cliente',

        status: {
            active: 'Ativo',
            actives: 'Ativos',
            compliant: 'Adimplentes',
            overdue: 'Inadimplentes',
            blocked: 'Bloqueado',
            blockeds: 'Bloqueados',
            trial: 'Trial',
            trials: 'Trials',
            expired: 'Expirado',
            deleted: 'Excluído',
            deleteds: 'Excluídos',
            canceleds: 'Cancelados',
            cancellationRequested: 'Cancelamento solicitado',
        },
        alerts: {
            delete: {
                title: 'Remover cliente?',
                message:
                    'O cancelamento do cliente {client} passará a contar a partir do <strong>mês subsequente</strong>, sendo gerado normalmente a fatura desse mês.<br><strong>Tem certeza?</strong>',
                'message-trial':
                    'Tem certeza que deseja remover o cliente {client}?</strong>',
                error: 'Erro ao deletar cliente {client}.',
                success: 'Cliente {client} deletado com sucesso.',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Cliente',
            },

            labels: {
                name: 'Nome',
                'trade-name': 'Nome Fantasia',
                legal_name: 'Razão Social',
                cpf: 'CPF',
                cnpj: 'CNPJ',
                'legal-person': 'Pessoa Jurídica',
                'normal-person': 'Pessoa Física',
                email: 'Email',
                phone: 'Telefone',
                status: 'Situação do cliente',
                responsible_name: 'Nome do Responsável',
                activity_area: 'Área de Atividade',
            },

            buttons: {
                clean: 'Limpar',
                save: 'Salvar',
                'select-modules': 'Selecionar Módulos do cliente',
            },

            bus: {
                'save-error': 'Preencha o formulário corretamente.',
                'save-recaptcha-error': 'Valide o recaptcha.',
                'save-success': 'Cliente {client} salvo com sucesso.',
            },

            messages: {
                'name-error-required': 'Nome é obrigatorio.',
                'name-error-max-length':
                    'O nome deve conter no máximo 180 caracteres.',
                'cpf-error-required':
                    'O CPF é obrigatório quando for pessoa física.',
                'cpf-error-min-length': 'Informe o CPF corretamente.',
                'cnpj-error-required':
                    'O CNPJ é obrigatório quando for pessoa jurídica.',
                'cnpj-error-min-length': 'Informe o CNPJ corretamente.',
                'email-error-required': 'O email é obrigatório.',
                'email-error-email': 'Informe um email válido.',
                'phone-error-required': 'O telefone é obrigatório.',
                'status-error-required': 'O status é obrigatório.',
                'phone-error-min-length':
                    'Informe um número de telefone válido.',
                'responsible-name-error-required':
                    'O nome do responsável é obrigatório',
                status: {
                    trial:
                        'Esta é uma conta temporária que tem validade de 15 dias para testes. Caso não ativada neste período, as informações da conta ficarão inacessíveis. Consulte nossa equipe em caso de dúvidas.',
                    active:
                        'Ao salvar esta conta como ativa, será gerado uma fatura a pagar para a ConnectPlug conforme os módulos selecionados. O cancelamento de módulos contratados precisa ser solicitado a connectplug pelo email canais@cplug.com.br e caso ocorra, será realizado na fatura do mês subsequente.',
                },
            },
        },
        show: {
            'title-prefix': 'Dados do',
        },
        plan: {
            title: 'Plano Ativo',
            'last-plan-name': 'Último plano selecionado',
            'plan-select-date': 'Data da seleção',
            'plan-value': 'Valor do plano',
            'plan-value-total': 'Valor a pagar para Cplug',
            'plan-value-customer': 'Valor cobrar do cliente',
            'payment-day': 'Dia de vencimento',
            modules: {
                title: 'Detalhes do Plano',
                table: {
                    headers: {
                        module: 'Módulo',
                        amount: 'Quantidade',
                        'cplug-value': 'Valor a pagar CPlug',
                        'customer-value': 'Valor a cobrar do cliente',
                        value: 'Valor',
                    },
                },
                discount: 'Desconto',
                'total-discount': 'Total com desconto',
                total: 'Total',
            },
        },
        period: {
            title: 'Faturas',
            table: {
                headers: {
                    start: 'Início',
                    end: 'Fim',
                    'due-date': 'Vencimento',
                    situation: 'Situação',
                    'payment-date': 'Pagamento',
                },
            },
        },

        index: {
            texts: {
                pending: 'Pendente',
                blocked: 'Bloqueado',
                active: 'Ativo',
                trial: 'Trial',
                'show-login-info': 'Exibir informações de login',
                'show-details': 'Ver detalhes',
            },

            buttons: {
                create: 'Adicionar cliente',
                'create-message':
                    'Para adicionar clientes é necessário primeiro criar um prospect.',
            },

            table: {
                'erp-id': 'Identificador ERP',
                contract_id: 'Schema',
                'trade-name': 'Nome fantasia',
                'legal-name': 'Razão Social',
                name: 'Nome',
                company: 'Empresa',
                contacts: 'Contatos',
                plan: 'Plano',
                'plan-value': 'Valor',
                document: 'Documento',
                email: 'Email',
                phone: 'Telefone',
                status: 'Status',
            },

            bus: {
                'delete-error': 'Erro ao remover o cliente {client}.',
                'delete-success': 'Cliente {client} removido com sucesso.',
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover o cliente {client}?',
            },

            information: {
                'erp-data': {
                    title: 'Informações de login',
                    'login-code': 'Código de login',
                    username: 'Usuário',
                    password: 'Senha',
                    information:
                        'Estes dados só serão exibidos no mesmo dia da criação da conta.',
                    error:
                        'A conta está sendo criada, aguarde alguns instantes.',
                },
            },
        },

        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },

        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
    },

    dashboard: {
        routes: {
            index: '',
        },
        texts: {
            interval: 'Intervalo:',
            'clients-total-interval': 'Total de clientes no período:',
            'clients-total': 'Total de clientes',
            'data-start': 'Data inicial:',
            'data-end': 'Data final:',
        },
    },

    files: {
        routes: {
            index: 'materiais-de-apoio',
        },
        breadcrumbs: {
            index: 'Materiais de Apoio',
        },
        index: {
            table: {
                preview: 'Prévia',
                title: 'Título',
                dimension: 'Dimensão',
            },

            texts: {
                view: 'Visualizar',
                description: 'Descrição',
                close: 'Fechar',
            },
        },
    },

    'forget-password': {
        routes: {
            index: 'esqueci-minha-senha',
        },

        texts: {
            title: 'Resetar Senha',
            resale: 'Programa de Parceria ConnectPlug',
        },

        labels: {
            email: 'Email',
        },

        buttons: {
            submit: 'Resetar',
            login: 'Voltar para o login',
        },

        bus: {
            'forget-password-error': 'Preencha o formulário corretamente.',
            'requisition-error':
                'Não foi possível fazer o pedido de recuperação de senha.',
        },

        messages: {
            'email-error-required': 'Email é obrigatório.',
            'email-error-email': 'Email deve conter um email válido.',
        },
    },

    'help-center': {
        routes: {
            index: 'ajuda',
        },
        breadcrumbs: {
            index: 'Central de Ajuda',
        },
    },

    loading: {
        routes: {
            index: 'carregando',
        },
    },

    login: {
        routes: {
            index: 'login',
        },
        texts: {
            title: 'Entrar',
            resale: 'Programa de Parceria ConnectPlug',
        },

        labels: {
            'tenant-code': 'Código da empresa',
            email: 'Email',
            password: 'Senha',
        },

        buttons: {
            submit: 'Entrar',
            'forget-password': 'Perdeu a senha?',
        },

        bus: {
            'login-error': 'Preencha o formulário corretamente.',
            'credentials-error': 'Credenciais inválidas.',
        },

        messages: {
            'tenant-code-error-required': 'Código da empresa é obrigatório.',
            'email-error-required': 'Email é obrigatório.',
            'email-error-email': 'Email deve conter um email válido.',
            'password-error-required': 'Senha é obrigatória.',
        },
    },

    modules: {
        index: {
            table: {
                headers: {
                    name: 'Nome',
                    cplug_price: 'Valor a pagar CPlug',
                    default_price: 'Valor a receber',
                },
            },
        },
        form: {
            title: '{prefix} Módulo',
            labels: {
                name: 'Nome',
                cplug_price: 'Preço CPlug',
                'customer-price': 'Valor a cobrar',
                type: 'Tipo de cobrança',
                'charge-amount': 'Cobrança por quantidade',
                'charge-normal': 'Cobrança pelo módulo',
            },
            validations: {
                'default-value': {
                    required: 'O preço do whitelabel é obrigatório',
                    between: 'O valor deve ser entre 0 e 99999999,99',
                },
            },
            messages: {
                success: 'Módulo {module} salvo com sucesso.',
            },
        },
        selection: {
            title: '{prefix} Plano',
            apps: 'Aplicativos',
            loading: 'Carregando Planos',
            'select-this-plan': 'Escolher esse plano',
            'select-plan': 'Selecionar plano',
            price: 'Valor a pagar para Cplug',
            'over-price': 'Preço para o cliente',
            'plan-selected': 'Plano escolhido',
            'plan-not-selected': 'Plano não escolhido ainda',

            confirm: {
                title: 'Cobrar do cliente',
                message:
                    'O valor a cobrar do cliente está menor que o valor a pagar para a ConnectPlug. Deseja manter assim?',
            },
        },
    },

    'action-log': {
        attributes: {
            userName: {
                system: 'Sistema',
            },
            action: {
                created: 'Criou',
                updated: 'Atualizou',
                deleted: 'Excluiu',
                restored: 'Restaurou',
            },
        },
    },

    prospects: {
        routes: {
            index: 'prospects',
            create: 'prospects/criar',
            edit: 'prospects/editar',
        },
        breadcrumbs: {
            index: 'Prospects',
            create: 'Novo',
            edit: 'Editar',
        },

        title: '{prefix} Prospect',

        index: {
            buttons: {
                create: 'Adicionar novo prospect',
                'create-trial': 'Criar conta de teste',
            },

            table: {
                'legal-name': 'Razão Social',
                'trade-name': 'Nome Fantasia',
                name: 'Nome',
                document: 'Documento',
                company: 'Empresa',
                client: 'Cliente',
                email: 'Email',
                phone: 'Telefone',
                contacts: 'Contatos',
                exclusive: 'Exclusividade',
                'valid-until': 'Data limite',
                'days-left': 'Dias restantes',
            },

            filters: {
                active: 'Ativos',
                inactive: 'Inativos',
            },

            messages: {
                'adding-client': 'Gerando cliente',
            },
        },

        alerts: {
            delete: {
                title: 'Remover prospect?',
                message:
                    'Tem certeza que deseja remover o prospect <strong>{prospect}</strong>?',
                error: 'Erro ao remover o prospect {prospect}.',
                success: 'Prospect {prospect} removido com sucesso.',
            },
            create: {
                title: 'Criar conta de teste?',
                message:
                    'Deseja criar uma conta de testes para o prospect <strong>{prospect}</strong>?',
                error:
                    'Erro ao criar conta de testes para o prospect {prospect}.',
                success:
                    'Conta de testes para o {prospect} criada com sucesso.',
            },
        },

        form: {
            'title-add': 'Adicionar Prospect',
            'title-edit': 'Editar Prospect',
            labels: {
                'legal-person': 'Pessoa Jurídica',
                'normal-person': 'Pessoa Física',
                birthday: 'Data de Nascimento',
            },
            messages: {
                success: 'Prospect {prospect} salvo com sucesso.',
            },
        },
    },

    permissions: {
        titles: {
            users: 'Usuários',
            customers: 'Clientes',
            leads: 'Prospects',
            bills: 'Faturas',
            colors: 'Cores',
            contents: 'Conteúdos',
            emails: 'Emails',
            modules: 'Módulos',
            reseller: 'Empresa',
            roles: 'Perfis de usuários',
            commissions: 'Comissão',
            address: 'Endereço',
            'bank-account': 'Contas bancárias',
            dashboard: 'Dashboard',
            contacts: 'Contatos',
            'landing-pages': 'Páginas de Captação',
            'mail-settings': 'E-mails',
        },
        names: {
            index: 'Listar',
            store: 'Adicionar',
            update: 'Atualizar',
            show: 'Exibir',
            delete: 'Remover',
            'create-customer': 'Gerar cliente',
            cancel: 'Cancelar',
        },
    },

    reseller: {
        routes: {
            edit: 'empresa',
        },
        breadcrumbs: {
            edit: 'Empresa',
        },
    },

    'reset-password': {
        routes: {
            index: 'reset-password',
        },
        texts: {
            title: 'Resetar Senha',
            resale: 'Programa de Parceria ConnectPlug',
        },

        labels: {
            password: 'Senha',
            password_confirmation: 'Confirmação da senha',
        },

        buttons: {
            submit: 'Resetar',
            login: 'Voltar para o login',
        },

        bus: {
            'request-error': 'Não foi possível alterar a sua senha.',
            'reset-password-success': 'Senha alterada com sucesso.',
        },
    },

    roles: {
        routes: {
            index: 'perfis-de-usuario',
            create: 'perfis-de-usuario/criar',
            edit: 'perfis-de-usuario/editar',
        },
        breadcrumbs: {
            index: 'Perfis de usuário',
            create: 'Criar',
            edit: 'Editar',
        },

        index: {
            buttons: {
                create: 'Adicionar Perfil de usuário',
            },
            table: {
                name: 'Nome',
                home: 'Página Inicial',
            },
            loading: 'Carregando...',

            filters: {
                active: 'Ativos',
                inactive: 'Inativos',
            },

            bus: {
                delete: {
                    error: 'Erro ao remover o perfil de usuário {role}.',
                    success: 'Perfil de usuário {role} removido com sucesso.',
                },
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover o perfil de usuário <strong>{role}</strong>?',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        edit: {
            texts: {
                'title-prefix': 'Editar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Perfil de Usuário',
                loading: 'Carregando permissões',
            },

            labels: {
                name: 'Nome',
                permissions: 'Permissões',
                home: 'Página Inicial',
            },

            buttons: {
                save: 'Salvar',
            },

            bus: {
                'save-success': 'Perfil de usuário {role} salvo com sucesso.',
            },

            errors: {
                'name-required': 'O campo nome é obrigatório.',
                'name-max-length':
                    'O campo nome deve ter no máximo 255 caracteres.',
            },
        },
    },

    user: {
        routes: {
            index: 'usuarios',
            create: 'usuarios/criar',
            edit: 'usuarios/editar',
        },
        breadcrumbs: {
            index: 'Usuários',
            create: 'Novo',
            edit: 'Editar',
        },
        'table-texts': {
            name: 'Nome',
            email: 'Email',
            actions: 'Ações',
        },
    },

    cookies: {
        title: 'Uso de cookies',
        description:
            ' - Guardamos estatísticas de visitas para melhorar sua experiência de navegação. Ao continuar, você concorda com nossa',
        cookies_policy: 'política de cookies.',
        agreeAndClose: 'Concordar e fechar',
    },

    certificates: {
        routes: {
            index: 'certificates',
            create: 'certificates/criar',
        },

        breadcrumbs: {
            index: 'Listar',
            create: 'Criar',
        },

        form: {
            texts: {
                titleInfo: 'Informações do certificado',
                titlePayment: 'Informações de pagamento',
            },

            labels: {
                certificateType: 'Selecione o tipo de certificado',
                customer: 'Cliente',
                name: 'Nome',
                document: 'Documento',
                email: 'E-mail',
                phone: 'Telefone',
                installments: 'Parcelas',
            },

            errors: {
                certificateType: 'Tipo de certificado obrigatório',
                customer: 'Cliente obrigatório',
                name: 'Nome obrigatório',
                document: 'Documento obrigatório',
                email: 'E-mail obrigatório',
                phone: 'Telefone obrigatório',
                paymentMethod: 'Forma de pagamento obrigatória',
                installments: 'Parcelas obrigatórias',
            },

            hints: {
                name: 'Nome para o qual deseja emitir o certificado',
                document: 'Documento para o qual deseja emitir o certificado',
                email:
                    'E-mail para receber os próximos passos para a emissão do certificado',
            },

            bus: {
                'validation-error': 'Preencha o formulário corretamente.',
            },
        },
    },

    'plan-proposal': {
        routes: {
            index: 'propostas-de-planos',
            create: 'propostas-de-planos/criar',
            show: 'propostas-de-planos/dados',
        },
        breadcrumbs: {
            index: 'Propostas de Planos',
            create: 'Criar',
            show: 'Dados',
        },

        index: {
            buttons: {
                create: 'Adicionar {resource}',
            },
            table: {
                customer: 'Cliente',
                plan: 'Plano',
                totalPrice: 'Valor Total',
                finalPrice: 'Valor Final',
                requestedAt: 'Data de Requisição',
                approvedAt: 'Data de Aprovação',
                rejectedAt: 'Data de Rejeição',
                expireAt: 'Data de Expiração',
                consultantName: 'Consultor',
            },
            loading: 'Carregando...',

            filters: {
                all: 'Todos',
                active: 'Ativos',
                inactive: 'Inativos',
            },

            bus: {
                'delete-error': 'Erro ao remover a proposta de plano #{id}.',
                'delete-success':
                    'Proposta de plano #{id} removida com sucesso.',
                'restore-error': 'Erro ao restaurar a proposta de plano #{id}.',
                'restore-success':
                    'Proposta de plano #{id} restaurada com sucesso.',
            },

            messages: {
                delete: 'Remover?',
                'delete-confirmation':
                    'Tem certeza que deseja remover a proposta de plano #{id}?',
                restore: 'Restaurar?',
                'restore-confirmation':
                    'Tem certeza que deseja restaurar a proposta de plano #{id}?',
            },
        },
        create: {
            texts: {
                'title-prefix': 'Adicionar',
            },
        },
        form: {
            texts: {
                title: '{title-prefix} Proposta de Plano',
            },

            buttons: {},

            bus: {
                'save-success': 'Proposta de plano salva com sucesso.',
            },

            errors: {},
        },
    },
}
